module.exports = __webpack_public_path__ + "static/media/background-certificado.8f343500.png";